import React from "react";
import NavBar from "../navBar/NavBar";

function Header({ nameUser, authServerAccess }) {
  return <NavBar nameUser={nameUser} authServerAccess={authServerAccess} />;
}
export default Header;
